
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  onBeforeMount,
  watch,
  computed,
  ref,
} from "vue";
import {
  apiGetCommunityDetail,
  apiGetNewGameLibrary,
  apiSearchCommunity,
} from "@api/gamelibs";

import { Popover, message } from "ant-design-vue";
import AppSvga from "@component/AppSvga/index.vue";
import { useRoute, useRouter } from "vue-router";
import { formatFloatNum } from "@js/utils";
import { isLogin } from "@js/account";
import LoginModal from "@/components/LoginModal/index.vue";
import { usePlayGameStore } from "@/store/playGame";
import { useGameListStore } from "@/store/gameList";
import { throttle } from "@js/utils";
import { useloginStore } from "@/store/login";
import BusinessManager from "@js/controls";
import CusModal from "@/components/CusModal/index.vue";

import type { yunpb } from "@/types/protobuf";
import SelectGameModal from "@/components/SelectGameModal/index.vue";

interface IRreactive {
  allTags: yunpb.ITagInfo[];
  gameList: yunpb.IGameLibraryCommunity[];
  hasGameListMore: boolean;
  isShowSelectGameModal: boolean;
  // 云游戏区父盒子dom
  sectionBoxDom: any;
  // 云游戏区滚动遮罩显隐
  isShowScrollMask: boolean;
  // 分页请求锁
  isLoadingNextPage: boolean;
  // 是否在初次加载
  loadingPage: boolean;
  selectGameData: yunpb.ICommunityDetail;
  page: number;
  // 展示搜索结果页面
  isShowSearchPage: boolean;
  // 搜索结果列表
  searchResultList: yunpb.IGameLibraryCommunity[];
  // 当前选中的社群标签id
  currentTagId: number;
  communityId: any;
}

export default defineComponent({
  components: {
    // Popover,
    CusModal,
    AppSvga,
    SelectGameModal,
  },
  name: "GameLibrary",
  setup() {
    const playGameStore = usePlayGameStore();
    const gameListStore = useGameListStore();
    const loginStore = useloginStore();
    const route = useRoute();
    const router = useRouter();
    const showCoinNotEnoughModal = ref(false);
    const data = reactive<IRreactive>({
      // 所有标签列表
      allTags: [],
      gameList: [],
      hasGameListMore: true, // 默认还有更多
      isShowSelectGameModal: false,
      isLoadingNextPage: false,
      selectGameData: {},
      page: 1,
      isShowSearchPage: false,
      loadingPage: false,
      searchResultList: [],
      currentTagId: 0,
      sectionBoxDom: null,
      isShowScrollMask: true,
      communityId: null,
    });
    const handleChangeCoinNotEnoughModal = (show: boolean) => {
      showCoinNotEnoughModal.value = show;
    };

    const handleShowRecharge = () => {
      showCoinNotEnoughModal.value = false;
      loginStore.update_isShowRecharge(true);
    };

    // 根据字段 isShowSearchPage 获取对应数据
    const getListByIsShowSearchPage = computed(() => {
      return data.isShowSearchPage ? data.searchResultList : data.gameList;
    });

    // 根据用户当前vip等级获取对应的游戏金币价格
    const getGameGoldsByVipType = (cloudGame: yunpb.ICloudGameNode) => {
      const curPrices = loginStore.userInfo?.vipInfo?.vipLevelType
        ? cloudGame.prices!.find(
            (val: yunpb.ICloudGamePrice) => val.priceType! > 1
          )
        : cloudGame.prices!.find(
            (val: yunpb.ICloudGamePrice) => val.priceType === 1
          );
      return curPrices?.price || 3;
    };

    // 选择标签
    const selectTag = (tagId: number) => {
      if (tagId === data.currentTagId) return;
      data.currentTagId = tagId;
      data.page = 1;
      getNewGameLibrary(true);
    };

    // 获取游戏社群列表
    const getNewGameLibrary = async (isShowPageLoad = false) => {
      try {
        if (isShowPageLoad) data.loadingPage = true;
        data.isLoadingNextPage = true;
        const tagId = (+route.query.tagId! || data.currentTagId || 0) as number;
        if (data.page === 1) data.gameList.length = 0;
        const res = await apiGetNewGameLibrary({
          tagId,
          page: data.page,
          filterType: 1,
        });
        console.log("getNewGameLibrarynext", res, "page", data.page);
        // 第一页就已经有全部的tag了，其他页不需要再赋值
        if (data.page === 1) data.allTags = res.allTags!;
        data.currentTagId = res.tagId!;
        data.hasGameListMore = res.more as boolean;
        data.gameList = data.gameList.concat(res.communitys!);
      } catch (err: any) {
        message.error(err?.rpcOut?.desc || "load fail");
        console.error(err);
      } finally {
        data.isLoadingNextPage = false;
        data.loadingPage = false;
      }
    };

    // 从游戏列表中选中游戏
    const selectGame = async (item: yunpb.IGetCommunityDetailReq) => {
      if (!isLogin()) {
        loginStore.setIsModalVisable(true);
        return;
      }
      data.communityId = item.communityId;
      console.log("选中社群id", item.communityId);
      return;
      // if (!isLogin()) {
      //   loginStore.setIsModalVisable(true);
      //   return;
      // }
      // try {
      //   const res = await apiGetCommunityDetail({
      //     communityId: item.communityId,
      //   });
      //   data.selectGameData = res.data!;
      //   data.isShowSelectGameModal = true;
      //   setTimeout(bindEventOnScrollMask);
      //   console.log("selectGame", res);
      // } catch (err: any) {
      //   message.error(err?.rpcOut?.desc || "load fail");
      //   console.error(err);
      // }
    };

    // 关闭选中游戏弹窗
    const selectGameModelClose = () => {
      console.log("关闭");
      data.communityId = null;
    };
    // 关闭选中游戏弹窗
    // const selectGameModelClose = () => {
    //   data.isShowSelectGameModal = false;
    //   data.sectionBoxDom.removeEventListener(
    //     "scroll",
    //     bindEventOnScrollMaskScroll
    //   );
    // };

    const bindEventOnScrollMaskScroll = (e: any) => {
      data.isShowScrollMask =
        e.target.scrollTop + e.target.offsetHeight < e.target.scrollHeight - 5;
    };

    // 为云游戏列表滚动内的滚动遮罩添加事件
    const bindEventOnScrollMask = () => {
      if (!data.selectGameData.gameInfo!.cloudGameList!.length!) return;
      console.log("data.sectionBoxDom", data.sectionBoxDom);
      // 默认显示
      data.isShowScrollMask = true;
      data.sectionBoxDom.scrollTop = 0;
      data.sectionBoxDom.addEventListener(
        "scroll",
        bindEventOnScrollMaskScroll
      );
    };
    // 购买商品处理函数
    const handlePayGoods = (item: yunpb.ICloudGameNode) => {
      // 3 是维护中
      if (item.gameStatus === 3) return;
      // 检查是否已购买
      if (!item.isNeedBuy) {
        // 再检查用户的金币是否足够玩游戏
        const gameGolds = getGameGoldsByVipType(item);
        if (loginStore.golds < gameGolds) {
          handleChangeCoinNotEnoughModal(true);
          return;
        }
        handlePlayGame(item.cloudGameId);
        return;
      }
      // 目前来说，只有这个地方是商品详情页的唯一入口，跳转前标记未购买状态，方便后续监听变化来购买刷新状态
      gameListStore.update_isBuyGoodSuccess(false);
      const target = router.resolve({
        path: "/GoodsDetail",
        query: {
          goods_id: item.goodsId,
        },
      });
      window.open(target.href, "_blank");
    };

    const handlePlayGame = async (gameId: number) => {
      const res = await BusinessManager.GetGameRoomInfo(gameId);
      console.log("游戏排队", res);

      const gameInfo = res && res.obj;
      // 启动游戏时关闭弹窗
      data.isShowSelectGameModal = false;
      window.gameStateMgr.playGame(gameInfo);
      // playGameStore.handlePlayGameMessage(gameInfo);
    };

    // 去商品详情页
    const gotoGoodsDetail = (item: any) => {
      console.log(item);
    };

    // 滚动分页
    const handleScroll = throttle(() => {
      // 没有更多时、加载中时、呈现搜索页时；均不会执行分页函数
      if (
        !data.hasGameListMore ||
        data.isLoadingNextPage ||
        data.isShowSearchPage
      )
        return;
      // 底部的版权模块高度240及其底边距120 .GameLibrary盒子的底边距32 再加上一定的阈值200 总和为240 + 120 + 32 + 100
      // 达到上述位置值时可以触发分页加载了
      if (
        492 >=
        document.body.scrollHeight - window.innerHeight - window.scrollY
      ) {
        data.page += 1;
        getNewGameLibrary();
      }
    }, 30);

    // 页面执行搜索逻辑
    const fetchDataWhenUseSearch = async (keyWord: string) => {
      try {
        if (!keyWord) {
          data.isShowSearchPage = false;
          data.searchResultList.length = 0;
          data.page = 1;
          getNewGameLibrary(true);
          return;
        }
        data.isShowSearchPage = true;
        const res = await apiSearchCommunity({
          searchMsg: keyWord,
          filterType: 1,
          page: 1,
          pageSize: 20, // 限定搜索20条
        });
        data.searchResultList = res.webCommunitySearchList!;
        console.log("fetchDataWhenUseSearch", res);
      } catch (err) {
        console.log(err);
      }
    };

    // 监听购买成功，此时要刷新点开的游戏
    watch(
      () => gameListStore.isBuyGoodSuccess,
      (newV: boolean) => {
        if (newV && data.isShowSelectGameModal) {
          // 刷新当前选择的数据
          console.log("购买成功啦");
          selectGame(
            data.selectGameData.baseInfo as yunpb.IGetCommunityDetailReq
          );
        }
      }
    );

    // 监听搜索参数变化
    watch(
      route,
      () => {
        console.log("searchKeyWord", route.query.search);
        fetchDataWhenUseSearch(route.query?.search as string);
      },
      { immediate: true }
    );
    onMounted(() => {
      console.log("GameLibrary route.query", route.query);

      window.scrollTo(0, 0);
      if (!route.query.search) getNewGameLibrary(true);
      window.addEventListener("scroll", handleScroll);
    });
    onBeforeMount(() => {
      console.log("onBeforeMount");
      window.removeEventListener("scroll", handleScroll);
    });
    return {
      route,
      getListByIsShowSearchPage,
      loginStore,
      selectTag,
      gotoGoodsDetail,
      selectGame,
      selectGameModelClose,
      formatFloatNum,
      handlePayGoods,
      getGameGoldsByVipType,
      ...toRefs(data),
      showCoinNotEnoughModal,
      handleChangeCoinNotEnoughModal,
      handleShowRecharge,
    };
  },
});
